import Stages from '@/services/Rest/Stages';

export default {
	state: {
		stages: {}
	},
	actions: {
		fetchStages({ commit, dispatch }) {
			return Stages.getStages().then(response => {
				commit('setStages', response.data.stages);

				return Promise.resolve(response);
			});
		},
		fetchStage({ commit, dispatch }, id) {
			return Stages.getStage(id);
		},
		storeStage({ commit, dispatch }, { title, type, status, color, color_id: colorId, datepicker }) {
			return Stages.storeStage(title, type, status, color, colorId, datepicker);
		},
		updateStage({ commit, dispatch }, { id, title, type, status, color, color_id: colorId, datepicker }) {
			return Stages.updateStage(id, title, type, status, color, colorId, datepicker);
		},
		deleteStage({ commit, dispatch }, data) {
			return Stages.deleteStage(data);
		},
		stageHistory({ commit, dispatch }, pivot) {
			return Stages.getStageHistory(pivot).then(
				response => { return Promise.resolve(response); },
				error => { return Promise.reject(error); }
			);
		},
		// Send email on matching and change stage
		sendPDF({ commit, dispatch }, obj) {
			return Stages.sendPDF(obj);
		},
		// Update stage note
		updateStageNote({ commit, dispatch }, obj) {
			return Stages.updateStageNote(obj);
		}
	},
	mutations: {
		setStages(state, data) {
			// const index = data.findIndex(item => item.title === 'Lead');
			// if (index !== -1) {
			// 	data.splice(index, 1);
			// }
			state.stages = data;
		}
	},
	getters: {
		getStages(state) {
			return state.stages;
		}
	}
};
